import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { MenuItem } from '@app/shared/models/menu.interface';
import { StateService } from '@components/data/data-table-new/state/state.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MenuResolverService } from '../services/resolvers/menu-resolver.service';

@Injectable({
  providedIn: 'root'
})
export class MenuGuard implements CanActivate {
  constructor(
    private router: Router,
    private menuResolverService: MenuResolverService,
    @Inject('StateService') protected stateService: StateService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.menuResolverService.resolve().pipe(
      map(entries => {
        const routeUrl = state.url;
        const isUrlInMenu: boolean = entries.some((entry: MenuItem) => {
          if (entry.children && entry.children.length > 0) {
            return entry.children.some(childEntry => this.urlMatches(childEntry.link, routeUrl));
          } else {
            return this.urlMatches(entry.link, routeUrl);
          }
        });
        if (!isUrlInMenu) {
          this.router.navigate(['/home']);
        }
        this.stateService.clearAllSearch();
        return isUrlInMenu;
      })
    );
  }

  private urlMatches(entryLink: string, routeUrl: string): boolean {
    const entrySplitted = entryLink.split('/', 2);
    const routeUrlSplitted = routeUrl.split('/', 2);
    return entryLink && entryLink !== '' && routeUrlSplitted[1].startsWith(entrySplitted[1]);
  }
}
